import React from 'react';

const NotFound = () => <div>Sorry, the page you were looking for couldn&apos;t be found.</div>;

NotFound.displayName = 'NotFound';

export default NotFound;
